import React from 'react';
import classNames from 'classnames';

import Button from '../../Button';

import styles from './UtilityCard.module.scss';

const { 'utility-card': utilityCardClass, framed: framedClass, 'button-cta': ctaClass } = styles;

const UtilityCard = props => {
  const {
    isBorderless,
    children,
    handleButtonClick,
    buttonCopy,
    buttonColor,
    buttonBorder,
    customClass,
    customButtonClass
  } = props;
  const utilityCardClasses = classNames(utilityCardClass, { [framedClass]: !isBorderless });

  return (
    <div className={`${utilityCardClasses} ${customClass}`}>
      {children}
      {handleButtonClick && (
        <div className={ctaClass}>
          <Button
            width="full"
            color={buttonColor}
            border={buttonBorder}
            clickAction={handleButtonClick}
            copy={buttonCopy}
            customClass={customButtonClass}
          />
        </div>
      )}
    </div>
  );
};

export default UtilityCard;
